module.exports = __webpack_public_path__ + "static/media/profile-thumbnail.c0111bfa.svg";